import { render } from "./resultsByPoints.vue?vue&type=template&id=70cd1934&scoped=true"
import script from "./resultsByPoints.vue?vue&type=script&lang=js"
export * from "./resultsByPoints.vue?vue&type=script&lang=js"

import "./resultsByPoints.vue?vue&type=style&index=0&id=70cd1934&scoped=true&lang=css"

import exportComponent from "/media/rafa/mainDisk/Documents/Raphael/Development/NavigationApplication/efoani/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70cd1934"]])

export default __exports__